import { forwardRef, memo } from "react";

import PropTypes from "prop-types";

import { StyledCustomTextField } from "./CustomTextField.styles";

/**
 * MemoizedCustomTextField is a reusable, styled text field component.
 *
 * @component
 * @param {Object} props - Component props
 * @param {string} props.variant - Material UI text field variant
 * @param {React.Ref} ref - Forwarded ref to the input element
 * @param {number} props.minLength - Minimum number of characters allowed
 * @param {number} props.maxLength - Maximum number of characters allowed
 * @param {Boolean} props.error - Boolean to check its an error state or not
 * @returns {JSX.Element} A styled input component
 */
const MemoizedCustomTextField = forwardRef(
	(
		{
			variant = "outlined",
			minLength = 0,
			maxLength = 256,
			error = false,
			...rest
		},
		ref
	) => (
		<StyledCustomTextField
			ref={ref}
			variant={variant}
			inputProps={{ minLength, maxLength }}
			error={error}
			InputProps={{
				...rest.InputProps,
			}}
			{...rest}
		/>
	)
);

MemoizedCustomTextField.displayName = "MemoizedCustomTextField";

MemoizedCustomTextField.propTypes = {
	variant: PropTypes.oneOf(["outlined", "filled", "standard"]),
	minLength: PropTypes.number,
	maxLength: PropTypes.number,
	error: PropTypes.bool,
};

const CustomTextField = memo(MemoizedCustomTextField);
CustomTextField.displayName = "CustomTextField";
export default CustomTextField;
